export class QuestionType {
  public static SingleSelect = '587b8deb-ebd7-46ed-9076-11a8025d5507';
  public static MultiSelect = '1ff46985-e008-42c4-a269-1034b8f03631';
  public static OpenEntry = 'd720c8d1-f56e-4e9e-8864-96e43a9a129d';
  public static SentenceCompletion = '5b45e578-a43d-4e93-913f-a8acad849068';
  public static DragAndDrop = '4a8dde38-6c34-44cf-af68-23f12aca901b';
}
